export { default as CmdbObjectCard } from './cmdb-object-card';
